"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FlightDetailsHeaderWeb_1 = __importDefault(require("../flight_details/FlightDetailsHeaderWeb"));
const RequestTimeLineRowWeb_1 = __importDefault(require("./RequestTimeLineRowWeb"));
const LocationRow_1 = __importDefault(require("../flight_details/LocationRow"));
const RequestDestinationTimelineWeb = ({ flightData }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FlightDetailsHeaderWeb_1.default, { flightData: flightData }), (0, jsx_runtime_1.jsx)(RequestTimeLineRowWeb_1.default, { showDetails: true }), (0, jsx_runtime_1.jsx)(LocationRow_1.default, { flightData: flightData })] }));
exports.default = RequestDestinationTimelineWeb;
